import React from 'react';
import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import { getAppName } from 'src/store/view/selectors';
import { useSelector } from 'react-redux';
import { MODULE_NAME } from 'src/constants';
import { Content, Description, Title } from './styles';

type Props = {
  submitMailConfirmation(): void;
};

export const MailConfirmation = ({ submitMailConfirmation }: Props) => {
  const { t } = useTranslation();

  const pageType = useSelector(getAppName);
  return (
    <>
      <Title>{t('checkout.mail.change.title')}</Title>
      <Description>{t('checkout.mail.change.description')}</Description>
      <Description>{t('checkout.mail.change.confirmation')}</Description>

      <Content>
        <Button
          size="flex"
          type="submit"
          primary
          onClick={submitMailConfirmation}
        >
          {pageType === MODULE_NAME.PACKAGE_CHECKOUT ||
          pageType === MODULE_NAME.HOTEL_CHECKOUT
            ? t('checkout.updateForm.footer')
            : t('checkout.updateForm.submit')}
        </Button>
      </Content>
    </>
  );
};
